import { useEffect, useMemo, useRef, useState } from 'react';
import _ from 'lodash';
import { useQuery } from '@tanstack/react-query';
import PageTabs from 'components/PageTabs';
import { TabPane } from 'reactstrap';
import { getUserGuide } from 'services/analysis';
import SideTabs from 'components/ui/SideTabs';
import { FixedCenterLoader } from 'components/Loaders';

function Content({ item }) {
  const paraValues = Object.keys(item)
    .filter((key) => /^Para \d+$/.test(key))
    .sort((a, b) => Number(a.split(' ')[1]) - Number(b.split(' ')[1]))
    .map((key) => item[key])
    .filter(Boolean);

  return (
    <>
      <h3 className="tw-w-full tw-text-left tw-text-3xl tw-font-bold tw-leading-tight tw-mt-0">{item['Layer 2']}</h3>
      {paraValues.map((para, i) => {
        return (
          <p key={para} className="tw-text-lg tw-text-left">
            {para}
          </p>
        );
      })}
    </>
  );
}

export default function Layer2({ page, session }) {
  const {
    data: userGuide,
    isLoading: isUserGuideLoading,
    isError: isUserGuideError,
    error: userGuideError,
    refetch: refetchUserGuide,
  } = useQuery({
    queryKey: ['userGuide', page],
    queryFn: () => getUserGuide(page),
  });

  const meta = useMemo(() => {
    if (!userGuide) return;

    const l1Keys = [];
    const l2ByL1Key = {};
    for (let row of userGuide) {
      const l1 = row['Layer 1'];
      const l2 = row['Layer 2'];

      if (!l2ByL1Key[l1]) {
        l1Keys.push(l1);
        l2ByL1Key[l1] = { keys: [], contentMap: {} };
      }

      if (!l2ByL1Key[l1].contentMap[l2]) {
        l2ByL1Key[l1].keys.push(l2);
        l2ByL1Key[l1].contentMap[l2] = <Content key={l2} item={row} />;
      }
    }

    return { l1Keys, l2ByL1Key };
  }, [userGuide]);

  if (isUserGuideLoading || !userGuide || !meta) {
    return <FixedCenterLoader />;
  }

  const tabs = meta.l1Keys.map((l1key, ind) => {
    const sideTabItems = meta.l2ByL1Key[l1key].keys.map((l2key) => ({
      id: l2key,
      label: l2key,
      content: meta.l2ByL1Key[l1key].contentMap[l2key],
    }));

    return {
      value: l1key,
      label: l1key,
      default: ind === 0,
      content: <SideTabs key={l1key} tabs={sideTabItems} />,
    };
  });

  return (
    <div className="tw-font-sans">
      <PageTabs options={tabs} session={session} colorIndex={0}>
        {tabs.map((tab) => (
          <TabPane tabId={tab.value} role="tabpanel" key={tab.value}>
            {tab.content}
          </TabPane>
        ))}
      </PageTabs>
    </div>
  );
}
